'use client';

import { TSetState } from '@/types/TSetState';
import { createContext, ReactNode, useContext, useState } from 'react';

type ContextTuple<T> = [T, TSetState<T>];

export default function ContextCreator<T>(defaultValue: T) {
  const Context = createContext<ContextTuple<T> | undefined>(undefined);

  const Provider = ({
    children,
    value: customValue,
  }: {
    children: ReactNode;
    value?: any;
  }) => {
    const [state, setState] = useState<T>(defaultValue);
    const value = customValue ?? [state, setState];
    return <Context.Provider value={value}>{children}</Context.Provider>;
  };

  const useCtx = (): ContextTuple<T> => {
    const context = useContext(Context);
    if (context === undefined) {
      throw new Error('useCtx must be used within a Provider');
    }
    return context;
  };

  return [Provider, useCtx] as const;
}
